// src/pages/conclusao-cadastro/ConclusaoCadastro.jsx
import styles from "./formulario.module.css";
import { useFormularioLogica } from "../Formulario/formularioLogica";

export default function ConclusaoCadastro() {
  const { codigo, copiado, copiarCodigo } = useFormularioLogica();
  return (
    <div className={styles["div_pai"]}>
      <div className={styles["div_marca"]}>
        <h1 className={styles["h1_titulo"]}>RoyalSofas</h1>
      </div>

      <div className={styles["div_filho"]}>
        <h2 className={styles["h2_filho"]}>Cadastro concluído com sucesso!</h2>

        {/* texto de apoio (mantive sem criar classe nova) */}
        <p
          style={{
            marginTop: 0,
            marginBottom: 18,
            textAlign: "center",
            fontFamily: "'Cormorant Garamond', serif",
            color: "rgba(126, 96, 66, 0.9)",
            fontSize: "1.25rem",
            padding: "0 24px",
          }}
        >
          Guarde o código abaixo para utilizar depois:
        </p>

        {/* usamos a class input_filho para o visual do “código” */}
        <input
          className={styles["input_filho"]}
          value={codigo}
          readOnly
          aria-label="Código de cadastro"
          style={{
            textAlign: "center",
            letterSpacing: "4px",
            fontWeight: 600,
          }}
        />

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
          <button className={styles["btn_filho"]} onClick={copiarCodigo} type="button">
            {copiado ? "Copiado!" : "Copiar código"}
          </button>

          <button
            className={styles["btn_filho"]}
            onClick={() => {
              // ajuste para a sua rota
              // ex: navigate("/home") ou window.location.href = "/"
              window.location.href = "/";
            }}
            type="button"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
}